import React from 'react';

import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import {
  CertOfAnalysisContactCard,
  DeliveryInstructionsCard,
  OrderConfirmationContactCard,
  ShipToAddressCard
} from '../../../../../../components/cards/shipTo';
import ShipToPage from '../../../../../../features/ShipTo';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  CONTACT_FIELDS,
  CONTACT_SAME_AS_FIELDS,
  DELIVERY_INSTRUCTIONS_FIELDS,
  SHIP_TO_ADDRESS_FIELDS
} from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Type Definitions -----------------
interface Field {
  key: string;
  required?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GenericComponent = React.ComponentType<any>;

interface Card {
  key: string;
  Component: GenericComponent;
  fields?: Field[];
  hideSameAs?: boolean;
  fieldWrapper?: string;
  sameAsFields?: string[];
}

interface Page {
  route: string;
  Component: GenericComponent;
  cards: Card[];
}

// ----------------- Page Template -----------------
const contactFields: Field[] = [
  { key: CONTACT_FIELDS.email },
  { key: CONTACT_FIELDS.fax }
];

const shipToPageTemplate: Page = {
  route: PAGE_ROUTES.shipTo,
  Component: ShipToPage,
  cards: [
    {
      key: CARD_CATEGORIES.address,
      Component: ShipToAddressCard,
      hideSameAs: true,
      fields: [
        { key: SHIP_TO_ADDRESS_FIELDS.address },
        { key: SHIP_TO_ADDRESS_FIELDS.email },
        { key: SHIP_TO_ADDRESS_FIELDS.taxNumber1 },
        { key: SHIP_TO_ADDRESS_FIELDS.taxNumber2 },
        { key: SHIP_TO_ADDRESS_FIELDS.taxNumber3 },
        { key: SHIP_TO_ADDRESS_FIELDS.taxNumber4 },
        { key: SHIP_TO_ADDRESS_FIELDS.telephone1 },
        { key: SHIP_TO_ADDRESS_FIELDS.telephone2 }
      ],
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.deliveryInstructions,
      Component: DeliveryInstructionsCard,
      fields: [
        { key: DELIVERY_INSTRUCTIONS_FIELDS.shippingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.externalInvoiceText },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.loadingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.unloadingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.packingInstructions },
        { key: DELIVERY_INSTRUCTIONS_FIELDS.billOfLadingText }
      ],
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    {
      key: CARD_CATEGORIES.coa,
      Component: CertOfAnalysisContactCard,
      fields: contactFields,
      fieldWrapper: CARD_CATEGORIES.shipTo
    },
    // {
    //   key: CARD_CATEGORIES.packingList,
    //   Component: PackingListContactCard,
    //   fields: contactFields,
    //   fieldWrapper: CARD_CATEGORIES.shipTo,
    //   sameAsFields: [CONTACT_SAME_AS_FIELDS.sameAsCoa],
    // },
    {
      key: CARD_CATEGORIES.orderConfirmation,
      Component: OrderConfirmationContactCard,
      fields: contactFields,
      fieldWrapper: CARD_CATEGORIES.shipTo,
      sameAsFields: [CONTACT_SAME_AS_FIELDS.sameAsCoa]
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

// ----------------- Export -----------------
const pages: Page[] = [shipToPageTemplate];

export default pages;